// test1898
(1898 && 0);
